export default "__VITE_ASSET__73c14793__"